import React, { Component } from 'react';
import Modal from 'react-modal';

import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { strings } from '../../../localization';

export default class RescindSharedRavenAccessModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            errorMessage: null,
        };
    }

    afterRescindSharedRavenAccessModalOpened = (e) => {
        Analytics.modalView('/rescindSharedRavenAccessModal');
        this.setState({
            errorMessage: null
        });
    }

    rescindSharedRavenAccess = (e) => {

        var email = this.props.email ? this.props.email : 'users\''
        var ravenName = this.props.raven && this.props.raven.vehicle && this.props.raven.vehicle.name ? this.props.raven.vehicle.name : 'this raven';
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_rescind_removing, email, ravenName), override: true } }));
        var ravenUuid = this.props.raven.ravenUuid;
        LambdaUtil.removeSharedRavenAccess(this.props.user.stage, this.props.email, this.onRescindSharedRavenAccessSuccess, this.onRescindSharedRavenAccessFail);
    }

    onRescindSharedRavenAccessSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            this.genericError(data);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        } else {
            document.documentElement.classList.remove("no-scroll");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_rescind_confirm), style: 'success', override: true } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
            return;
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onRescindSharedRavenAccessFail = (data) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.genericError(data);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    genericError(data) {

        if (data) console.error(data);
        this.setState({
            errorMessage: strings.formatString(strings.raven_rescind_error_generic)
        });
    }

    render() {

        if (!this.props.rescindUser) return null

        var userName = this.props.rescindUser.email;
        if (this.props.rescindUser.driverName) {
            userName = this.props.rescindUser.driverName + ' (' + this.props.rescindUser.email + ')';
        }
        return (
            <Modal isOpen={this.props.rescindAccessModalOpen}
                contentLabel="edit-plan-modal"
                className="react-modal-content react-modal-sm"
                overlayClassName="react-modal-overlay"
                onRequestClose={this.props.closeRescindAccessModal}
                onAfterOpen={this.afterRescindSharedRavenAccessModalOpened}>

                <div className="container-fluid form-card">

                    <h2><i className="material-icons">remove_circle</i>{strings.formatString(strings.raven_rescind_title)}</h2>
                    <p>{strings.formatString(strings.ravenn_rescind_message, <em className="blue">{this.props.raven.vehicle.name}</em>)}</p>
                    <p className="blue">{userName}</p>
                    <p>{strings.formatString(strings.raven_rescind_message2)}</p>
                    <div className="row">
                        <div className="col-12 action-btns text-right">
                            <button className="btn btn-outline-blue" onClick={this.props.closeRescindAccessModal}><i className="material-icons">close</i>{strings.formatString(strings.app_cancel)}</button>
                            <button className="btn" onClick={this.rescindSharedRavenAccess}><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.remove_access)}</button>

                            <div>{(this.state.errorMessage) ? (<p className="error-message"><i className="material-icons">error_outline</i><span>{this.state.errorMessage}</span></p>) : null}</div>
                        </div>
                    </div>

                </div>
            </Modal>
        );
    }
}
